import { ReactElement } from 'react';

import { ResultTypes } from '@cashier/cashier-model';

import { usePaymentResult } from '../hooks';
import { InformationBlock } from '../modules/informationBlock/v1';
import { StatusBlock } from '../modules/statusBlock/v1';

export interface PaymentResultProps {
  amount: string;
  currency: string;
}

export const PaymentResult = ({
  amount,
  currency,
}: PaymentResultProps): ReactElement => {
  const { resultType, paymentMethodMessage, informationFields, onButtonClick } =
    usePaymentResult();

  return (
    <>
      {resultType === ResultTypes.INFORMATION && (
        <InformationBlock
          amount={amount}
          currency={currency}
          fields={informationFields}
          paymentMethodMessage={paymentMethodMessage}
          onButtonClick={onButtonClick}
        />
      )}
      {resultType === ResultTypes.STATUS && (
        <StatusBlock
          amount={amount}
          currency={currency}
          paymentMethodMessage={paymentMethodMessage}
          onButtonClick={onButtonClick}
        />
      )}
    </>
  );
};
